import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import QRCodeList from './components/QRCodeList';
import Login from './components/Login';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <QRCodeList />,
    },
    {
      path: '/login',
      element: <Login />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatRoutes: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
      v7_relativeSplatPath: true,
    },
  }
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;